<template>
  <div class="auth-wrapper auth-v2">
    <div class="vx-row auth-inner m-0">
      <!-- Brand logo-->
      <div class="brand-logo d-none lg:flex">
        <img
          src="@/assets/images/project/hexasense-logo.png"
          alt="logo"
          width="200px"
          height="100%"
        />
      </div>
      <!-- /Brand logo-->

      <!-- Left Text-->
      <div
        class="vx-col w-full lg:w-7/12 xl:w-2/3 d-none lg:flex items-center p-5"
      >
        <div class="w-full lg:flex items-center justify-center px-5">
          <img :src="imgUrl" width="70%" height="70%" alt="Login" />
        </div>
      </div>
      <!-- /Left Text-->

      <div
        class="vx-col w-full lg:w-5/12 xl:w-1/3 flex items-center auth-bg p-5"
      >
        <div
          class="
            vx-col
            w-full
            sm:w-3/4
            md:w-7/12
            lg:w-full
            xl:w-full
            mx-auto
            mobil-vx-card
            p-10
          "
        >
          <div class="mb-5 brand-logo-v2">
            <img
              src="@/assets/images/project/hexasense-logo.png"
              alt="logo"
              width="200px"
              height="100%"
            />
          </div>
          <div class="mt-6">
            <div
              class="
                text-center
                flex
                items-center
                justify-center
                w-full
                height-200
              "
              v-if="isPageLoading == true"
            >
              <feather-icon
                icon="LoaderIcon"
                class="mr-3 bx-spin text-warning"
                svgClasses="w-50 h-50"
              ></feather-icon>
            </div>
            <div v-else>
              <div class="h4 mb-2 text-center">{{ $t("register.activated.Welcome") }}!</div>
              <template v-if="control == false">
                <div class="mt-4 mb-4">
                  <span class="text-center text-danger">{{
                    errorMessage
                  }}</span>
                </div>
                <i18n
                  path="register.activated.RedirectRegister.text"
                  tag="span"
                >
                  <template v-slot:button>
                    <span
                      class="text-warning text-underline cursor-pointer"
                      @click="$router.push('/register').catch(() => {})"
                    >
                      {{ $t("register.activated.RedirectRegister.button") }}
                    </span>
                  </template>
                </i18n>
              </template>
              <template v-else-if="control == true">
                <div class="text-center mt-4">
                  <div class="mb-1">
                    {{ $t("register.activated.success.title") }}
                  </div>
                  <div class="mb-4">
                    {{ $t("register.activated.success.text") }}
                  </div>
                </div>
                <div class="flex items-center justify-center w-full my-8">
                  <div>
                    <feather-icon
                      icon="LoaderIcon"
                      class="mr-3 bx-spin text-warning"
                      svgClasses="w-10 h-10"
                    ></feather-icon>
                  </div>
                </div>
              </template>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import i18n from '../../i18n/i18n.js'
import Footer from './components/footer.vue'

export default {
  components: {
    'auth-footer': Footer
  },
  data () {
    return {
      control: '',
      errorMessage: '',
      isPageLoading: true,
      imgUrl: require('@/assets/images/pages/activated.png')
    }
  },
  mounted () {
    this.isPageLoading = true
    this.$store
      .dispatch('activateControl', this.$route.params.id)
      .then(() => {
        this.control = true
        this.isPageLoading = false
        const that = this
        setTimeout(function () {
          that.$router.push('/login').catch(() => {})
        }, 3000)
      })
      .catch((error) => {
        this.control = false
        this.isPageLoading = false
        if (error.response.status === 500) {
          this.$vs.notify({
            title: i18n.t('notifyAlert.error.title'),
            text: i18n.t('messagebox.WrongActivationCode'),
            iconPack: 'feather',
            icon: 'icon-alert-circle',
            color: 'danger',
            position: 'top-right'
          })
        } else {
          this.errorMsg(error)
        }
      })
  },
  errorMsg (error) {
    this.$store.dispatch('errorMsg', error).then((res) => {
      this.$vs.notify({
        title: i18n.t('notifyAlert.error.title'),
        text: res,
        iconPack: 'feather',
        icon: 'icon-alert-circle',
        color: 'danger',
        position: 'top-right'
      })
    })
  }
}
</script>

<style lang="scss">
@import "../../assets/scss/vuexy/pages/page-auth.scss";
</style>
